import { ValidateJobNumberRequest, type ValidateJobNumberResponse } from '@kalos/kalos-rpc';
import { useQuery } from '@tanstack/react-query';

import { EventClientService } from '../../tools/helpers';
import { queryKeys } from './constants';

export type ValidateJobNumberFilter = {
  jobNumber: number;
  departmentId?: number;
};

/** Query options for ValidateJobNumber, shared by the hook and by useQueries callers. */
export const validateJobNumberQueryOptions = (jobNumber: number, departmentId = 0) => ({
  queryKey: [
    queryKeys.events.root,
    queryKeys.events.validateJobNumber,
    queryKeys.events.getValidateJobNumberHash(jobNumber, departmentId),
  ],
  queryFn: async (): Promise<ValidateJobNumberResponse> => {
    const req = ValidateJobNumberRequest.create({ jobNumber, departmentId });
    return await EventClientService.ValidateJobNumber(req);
  },
});

export const useValidateJobNumberQuery = ({
  jobNumber,
  departmentId = 0,
  enabled = true,
  staleTime,
}: {
  jobNumber: number;
  departmentId?: number;
  enabled?: boolean;
  staleTime?: number;
}) => {
  return useQuery({
    ...validateJobNumberQueryOptions(jobNumber, departmentId),
    enabled: enabled && jobNumber > 0,
    staleTime,
  });
};
